/**
 * User: nir
 * Date: 05/09/2016
 * Time: 13:24
 */

if (window.jQuery) {
    // Share Icons //
    jQuery(function ($) {
        var panel = $('ul[data-action="update-share"]');

        if (!panel || !panel.length) return;

        var articleContent = $('section[data-type="article-content"]');
        var runCss = false,
            isSticky = true,
            onlyStickBottom = false,
            isFubButton= false,
            endOfContentTop = 0;
        if (panel.length !== 0 && articleContent !== 0) {
            var wrapper = $('.article #content-wrap .share-icons');

            function runTest() {

                var d = $.Deferred();

                if (!shouldRunTest()) return d.resolve();


                var iconSelector = $('.disc-icon.social', wrapper);

                TCT.Testing.getTestData(980, null).then(function (data) {
                    TCT.debug('Test data:', data);

                    if (data && data.variant) { // for extra safety
                        var shareIconVariant = data.variant,
                            shareIconInstruction = data.instruction;

                        if (iconSelector.length > 0 ) {

                            switch (shareIconVariant) {
                                case "TEST920_BOTTOM_ICONS" :
                                    runCss = true;
                                    break;
                                case "TEST980_NON_STICKY_TOP_AND_BOTTOM":
                                  var iconDictionary = {
                                    "#facebook-icon":"#facebook-icon-dark",
                                    "#twitter-icon":"#twitter-icon-dark",
                                    "#pinterest-icon":"#pinterest-icon-dark",
                                    "#whatsapp-icon":"#whatsapp-icon-dark",
                                    "#letter-icon":"#letter-icon-dark"
                                  };

                                  isSticky = false;
                                  changeIconSvg(iconDictionary);
                                  iconSelector.css({"background-color":"transparent"});
                                  $('ul.share-icons').addClass("not-sticky");
                                  $('.icon', iconSelector).addClass("not-sticky");

                                  var relatedArticle = $('section.related-articles');
                                  if (relatedArticle && relatedArticle.length>0){
                                    relatedArticle.css("border-top","solid #aeaeae 1px");
                                  }

                                  break;

                              case "TEST980_STICKY_BOTTOM":
                                var iconDictionary = {
                                  "#facebook-icon":"#facebook-icon-outline",
                                  "#twitter-icon":"#twitter-icon-outline",
                                  "#pinterest-icon":"#pinterest-icon-outline",
                                  "#whatsapp-icon":"#whatsapp-icon-outline",
                                  "#letter-icon":"#letter-icon-outline"
                                };
                                endOfContentTop = $('.related-articles').offset().top ;
                                changeIconSvg(iconDictionary);
                                iconSelector.css({"background-color":"transparent"});
                                $('ul.share-icons').addClass("sticky-bottom");
                                $('.icon', iconSelector).addClass("sticky-bottom");

                                onlyStickBottom = true;
                                break;
                              case "TEST980_FLOATING_ACTION_BUTTON":
                                isFubButton= true;
                                endOfContentTop = $('.related-articles').offset().top ;
                                angular.element(document).ready(function () {
                                  var element = document.getElementById('fab-social-button');
                                  angular.bootstrap(element, ['socialFabButton']);

                                });
                                var fabShare = $('#fab-social-button');
                                fabShare.addClass('before-offset');
                                break;
                                default:
                                    console.log('no test here');
                                    break;
                            }

                            // track variant visible
                            TCT.Testing.reportVariantVisible(data);
                        }
                    }

                    d.resolve();
                }, d.resolve);


                return d.promise();
            }

            runTest().then(init);

            function init() {
                wrapper.show();
                var $window = $(window);
                var body = $('body');
                var clone = panel.clone();

                clone.addClass('fixed');

                $window.on('scroll resize', function () {
                    if ($('#branch-banner').length > 0 && $('#branch-banner').height() == 80){
                        $('.share-icons.fixed').addClass('smaller');
                    }
                    var top = panel.offset().top;
                    var vertical = (panel.css('flex-direction') === 'column');
                    var windowScrollTop = $window.scrollTop();
                    var articleTop = articleContent.offset().top;
                    var articleHeight = articleContent.height();
                    var panelHeight = panel.outerHeight();
                    var articleBottom = articleTop + articleHeight - panelHeight;
                    var left = panel.offset().left;
                    var offsetParent = articleContent.offsetParent();
                    var absTop = offsetParent.offset().top + articleContent.position().top + articleContent.height() - panelHeight;
                    clone.toggleClass('vertical', vertical);

                    // TCT.debug('windowScrollTop: %d, articleTop: %d, panelHeight: %d, articleBottom: %d', windowScrollTop, articleTop, panelHeight, articleBottom);
                    // TCT.debug('vertical:', vertical);
                    // TCT.debug('left:', left);

                    if (vertical) {

                        if (windowScrollTop >= top && windowScrollTop <= articleBottom) {
                            clone.removeAttr('style').toggleClass('absolute', false).css('left', left);
                            if (!clone.is('.shown')) {
                                clone.hide().toggleClass('shown', true).appendTo(body).show();
                                panel.toggleClass('transparent', true);
                            }
                        } else if (windowScrollTop > articleBottom) {
                            clone.toggleClass('absolute', true).css({
                                position: 'absolute',
                                top: absTop
                            });
                        } else {
                            clone.toggleClass('shown', false).hide().remove();
                            panel.toggleClass('transparent', false);
                        }
                    }
                    else if (isSticky && !onlyStickBottom && !isFubButton) {
                        if ( windowScrollTop >= top && windowScrollTop <= articleBottom) {
                            clone.removeAttr('style').toggleClass('absolute', false).css('left', left);
                            if (!clone.is('.shown')) {
                                clone.hide().toggleClass('shown', true).appendTo(body).show();
                                panel.toggleClass('transparent', true);
                            }
                        } else if (windowScrollTop > articleBottom) {
                          clone.toggleClass('absolute', true).css({
                            position: 'absolute',
                            top: absTop
                          });
                        } else {
                            clone.toggleClass('shown', false).hide().remove();
                            panel.toggleClass('transparent', false);
                        }

                        if(runCss == true){
                            $('ul.share-icons.fixed.shown').css({
                                'bottom': 0,
                                'top': 'auto',
                                'background':'#fff',
                                'width':'100%',
                                'left': 0,
                                'height': '55px',
                                'padding': 0,
                                'margin' : 0
                            });
                            $('.article-back-to-top').css('bottom', '57px');
                        }
                    }
                    else if (isFubButton){
                      var goUpButton = $('#goUpButton'),
                          fabShare = $('#fab-social-button'),
                          offset = 10;

                      if (fabShare.hasClass('before-offset') && $(this).scrollTop() > offset) {
                        fabShare.removeClass('before-offset');
                        fabShare.fadeIn(300);
                      } else if (!fabShare.hasClass('before-offset') && $(this).scrollTop() < offset) {
                        fabShare.addClass('before-offset');
                        fabShare.fadeOut(300);
                      }
                      panel.css("display","none");
                      goUpButton.addClass('share-fab');

                      if (windowScrollTop+$window.height()  > endOfContentTop && !fabShare.hasClass('end-of-content')) {
                        fabShare.addClass('end-of-content');
                        fabShare.fadeOut(300);
                      }
                      else if (windowScrollTop+$window.height() <= endOfContentTop && fabShare.hasClass('end-of-content'))
                      {
                        fabShare.removeClass('end-of-content');
                        fabShare.fadeIn(300);
                      }

                    }
                    //This will put the icons at the end of the article content
                    else if (onlyStickBottom){
                        var cookieBanner = $('#cookie-policy-banner'),
                          goUpButton = $('#goUpButton');


                        if (windowScrollTop+$window.height()  > endOfContentTop && panel.hasClass('share-stick-Bottom')) {
                          panel.removeClass('share-stick-Bottom');
                          goUpButton.removeClass('share-stick-Bottom');
                          if ( cookieBanner.length > 0 ){
                            cookieBanner.removeClass('share-stick-Bottom');
                          }

                        }
                        else if (windowScrollTop+$window.height() <= endOfContentTop && !panel.hasClass('share-stick-Bottom'))
                        {
                          panel.addClass('share-stick-Bottom');
                          goUpButton.addClass('share-stick-Bottom');

                          if ( cookieBanner.length > 0 ){
                            cookieBanner.addClass('share-stick-Bottom');
                          }
                        }

                    }
                    else if (!isSticky) {
                      var endOfContentDiv = $('#end-of-content');

                      if (endOfContentDiv && !clone.hasClass('in-end-of-content')){
                        clone.addClass('in-end-of-content');
                        clone.removeAttr('style').toggleClass('absolute', false).css('left', left);
                        clone.hide().toggleClass('shown', true).appendTo(body).show();
                        clone.css({
                          "margin-bottom" : "0",
                          "position" : "sticky"
                        });
                        endOfContentDiv.append(clone);
                      }
                    }

                }).trigger('scroll');

            }
        }

        function shouldRunTest() {
            return false;
        }

        function checkAndAddStyle(selector, style) {
            if (selector.length > 0 && style !== null) {
                selector.css(style);
            }
        }
        function changeIconSvg(iconDictionary) {
          var iconUseElements = document.querySelectorAll(".article #content-wrap .share-icons .disc-icon.social use");

          if (iconUseElements && iconUseElements.length>0){
            iconUseElements.forEach(function(icon){
              icon.setAttributeNS('http://www.w3.org/1999/xlink', 'href', iconDictionary[icon.getAttribute('xlink:href')]);
            });
          }
        }
    });
    // END - Share Icons //
}
